import { schema } from 'normalizr';
import city from './city';
import tag from './tag';
import tip from './tip';
import user from './user';

const eatery = new schema.Entity(
  'eatery',
  {
    owner: user,
    city,
    curatorTips: [tip],
    mustTryDishes: {
      dishes: [tag],
    },
    alsoServes: {
      dishes: [tag],
    },
    tags: [tag],
  },
  { idAttribute: 'linkTitle' }
);

export default eatery;
